export default __webpack_public_path__ + "static/media/25.03978212.png";